import React, { useState } from "react";
import "../../styles/admins/user_profile.css";
import logo from "../../images/user.png";
import axios from "axios";

function TechieProfile({ clientDetails, handleToast }) {
  const [formData, setFormData] = useState({
    name: clientDetails.name || "",
    staff_id: clientDetails.staff_id || "",
    pass: clientDetails.pass || "",
    company_id: clientDetails.company_id || "",
    comp_id: clientDetails.comp_id || "",
    company_name: clientDetails.company_name || "",
    contact: clientDetails.contact || "",
    email: clientDetails.email || "",
    designation: clientDetails.designation || "",
    is_admin: clientDetails.is_admin || "",
    id: clientDetails.id || "",
    added_on: clientDetails.added_on,
    location: clientDetails.location,
    comp_contact: clientDetails.comp_contact,

        image: null,
  currentImage: clientDetails.image || null ,
  });

  //   const [companies, setCompanies] = useState([]);

  //   // Fetch companies
  //   useEffect(() => {
  //     const getCompanies = async () => {
  //       try {
  //         const response = await axios.get("https://api.dectwinservices.com/api/companies");
  //         setCompanies(response.data);
  //       } catch (e) {
  //         handleToast({
  //           toastMsg:
  //             "Something went wrong! Please Refresh page or check internet.",
  //           toastColor: "#FF0000",
  //         });
  //       }
  //     };
  //     getCompanies();
  //   }, [handleToast]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // Submit form data
  const handleSubmit = async (e) => {
    e.preventDefault();

    const formDataToSend = new FormData();

Object.keys(formData).forEach((key) => {
  if (key === "image") {
    if (formData.image) {
      formDataToSend.append("image", formData.image);
    }
  } else {
    formDataToSend.append(key, formData[key]);
  }
});

    try {
      // await axios.put(
      //   "https://api.dectwinservices.com/api/update-techie",
      //   formData
      // );

           
      const response = await axios.put(
        "https://api.dectwinservices.com/api/update-techie",
        formDataToSend,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      handleToast({
        toastMsg: "User Updated Successfully!!!",
        toastColor: "#4CAF50",
      });
      localStorage.removeItem("exclserv_user");
      // localStorage.setItem("exclserv_user", JSON.stringify(formData));
    
      const updatedUser = {
  ...formData,
  image: response.data.image,   
  currentImage: response.data.image,
};

localStorage.setItem(
  "exclserv_user",
  JSON.stringify(updatedUser)
);
        

      setTimeout(() => {
        window.location.reload();
      }, 1500);
    } catch (error) {
      handleToast({
        toastMsg: "Something went wrong! Please check data or internet.",
        toastColor: "#FF0000",
      });
    }
  };

  return (
    <section className="profile px-4">
      <div className="left-side my-4"></div>
      <div className="right-side">
          <div className="top-profile p-3 text-md-start text-center">
      
<div className="row">

    <div className="col-md-6 col-sm-6 col-12">
  <img
        src={
          typeof formData.currentImage === "string" &&
          formData.currentImage
            ? formData.currentImage.startsWith("blob:")
              ? formData.currentImage
              : `https://api.dectwinservices.com/uploads/${formData.currentImage}`
            : logo
        }
        alt="Profile"
        className="profile-image"
      />
      </div>
      




<div className="align-content-center name col-md-6 col-sm-6 col-12">
  <p>Hello, {clientDetails.name}</p>
      </div>        </div>
</div>

        <form className="add-prod-form edit-prof" onSubmit={handleSubmit}>
          <div className="row">

          <div className="form-data col-lg-4 col-md-6 col-12">
            <label htmlFor="staff_name">Technician Name</label>
            <div className="input-icon">
              <i className="bx bxs-layer"></i>
              <input
                type="text"
                name="name"
                id="name"
                value={formData.name}
                onChange={handleChange}
                placeholder="Enter Technician Name"
                required
              />
            </div>
          </div>

          <div className="form-data col-lg-4 col-md-6 col-12">
            <label htmlFor="staff_id">Technician ID</label>
            <div className="input-icon">
              <i className="bx bx-id-card"></i>
              <input
                type="text"
                name="staff_id"
                id="staff_id"
                value={formData.staff_id}
                onChange={handleChange}
                placeholder="Enter Technician ID"
                required
                // disabled={!!clientDetails.name}
              />
            </div>
          </div>

          <div className="form-data col-lg-4 col-md-6 col-12">
            <label htmlFor="pass">Create Password</label>
            <div className="input-icon">
              <i className="bx bxs-lock"></i>
              <input
                type="text"
                name="pass"
                id="pass"
                value={formData.pass}
                onChange={handleChange}
                placeholder="Create Password"
                required
              />
            </div>
          </div>

          <div className="form-data col-lg-4 col-md-6 col-12">
            <label htmlFor="comp_id">Assigned Company</label>
            <div className="input-icon">
              <i className="bx bxs-user"></i>
              <select
                name="company_id"
                id="company_id"
                style={{backgroundColor: 'var(--gray)'}}
                value={formData.company_name}
                onChange={handleChange}
                required
                disabled
              >
                <option value="">Assigned Company</option>
                <option value={formData.company_name}>
                  {formData.company_name}
                </option>
              </select>
            </div>
          </div>

          <div className="form-data col-lg-4 col-md-6 col-12">
            <label htmlFor="contact">User Contact</label>
            <div className="input-icon">
              <i className="bx bx-phone"></i>
              <input
                type="text"
                name="contact"
                id="contact"
                placeholder="Enter User Contact"
                value={formData.contact}
                onChange={handleChange}
                pattern="[0-9]*"
  maxLength={10}
              />
            </div>
          </div>

          <div className="form-data col-lg-4 col-md-6 col-12">
            <label htmlFor="email">User Email</label>
            <div className="input-icon">
              <i className="bx bx-envelope"></i>
              <input
                type="email"
                name="email"
                id="email"
                placeholder="Enter User Email"
                value={formData.email}
                onChange={handleChange}
              />
            </div>
          </div>

          <div className="form-data col-lg-4 col-md-6 col-12">
            <label htmlFor="designation">User Designation</label>
            <div className="input-icon">
              <i className="bx bx-briefcase"></i>
              <input
                type="text"
                name="designation"
                id="designation"
                placeholder="Enter User Designation"
                value={formData.designation}
                onChange={handleChange}
              />
            </div>
          </div>
          
                 <div className="form-data col-lg-4 col-md-6 col-12">
  <label htmlFor="image">Profile Image</label>

  <div className="input-icon">
    <i className="bx bx-image"></i>

    <input
      type="file"
      id="image"
      accept="image/*"
      onChange={(e) => {
        const file = e.target.files[0];

        setFormData((prev) => ({
          ...prev,
          image: file,
          currentImage: URL.createObjectURL(file),
        }));
      }}
    />
  </div>
</div>

          <div
            className="form-data"
            style={{
              justifyContent: "flex-end",
              alignItems: "flex-end",
              paddingBottom: "10px",
            }}
          >
            <button
              style={{ width: "140px" }}
              type="submit"
              className="button-85"
            >
              Edit Profile
            </button>
          </div>
          </div>
        </form>
      </div>
    </section>
  );
}

export default TechieProfile;
